<template lang="pug">
  section.advantages(data-id=`advantages`)
    .advantages__block.wrapper-p
      .advantages__img-wrapper
        .advantages__img
          base-picture(
            :imgClass="pictures[0].imgClass"
            :minScreenWidth="pictures[0].minScreenWidth"
            :desktopName="pictures[0].desktopName"
            :mobileName="pictures[0].mobileName"
            :alt="pictures[0].alt"
          )

      .advantages__content
        h2.advantages__title.clr-black.t-h2 Центральный бортовой компьютер
        p.advantages__text Центральный бортовой компьютер (ЦБК) объединяет в едином интерфейсе функции управления, мониторинга, диагностики и настройки всех подсистем бортового оборудования

        h4.advantages__subtitle.clr-d-grey.t-h4 В ЦБК интегрированы системы:

        base-list.advantages__list(:elements="lists.blocks[0].items")

        a.advantages__download.btn.btn--fill.t-tdn(
          href=`upload/ЦБК_Руководство_по_эксплуатации_v1.pdf`
          download
        )
          svg(xmlns=`http://www.w3.org/2000/svg`)
            use(:href="$setSvgHref(`img/sprite.svg#i-file`)")
          span.btn__text.t-ttu ЦБК. Руководство по эксплуатации

    .advantages__block.advantages__block--reverse.bg-xl-blue.wrapper-p
      .advantages__img-wrapper
        .advantages__img
          base-picture(
            :imgClass="pictures[1].imgClass"
            :minScreenWidth="pictures[1].minScreenWidth"
            :desktopName="pictures[1].desktopName"
            :mobileName="pictures[1].mobileName"
            :alt="pictures[1].alt"
          )
          .advantages__img-caption Бортовой компьютер с сенсорным экраном

      .advantages__content
        h2.advantages__title.clr-black.t-h2 ЦБК как «спрут» охватывает все системы бортового оборудования
        p.advantages__text Это позволяет организовать централизированный мониторинг и обслуживание систем

        h4.advantages__subtitle.clr-d-grey.t-h4 Задачи ЦБК

        base-list.advantages__list(:elements="lists.blocks[1].items")

    .advantages__block.wrapper-p
      .advantages__img-wrapper
        .advantages__img
          svg(xmlns=`http://www.w3.org/2000/svg`)
            use(:href="$setSvgHref(`img/sprite.svg#${pictures[2].svgName}`)")

      .advantages__content
        h2.advantages__title.clr-black.t-h2 Архитерктура телематической системы со встроенным ЦБК

        p.advantages__video-caption.clr-black Видеопрезентация
        a.advantages__video(
          href=`https://www.youtube.com/watch?v=I-s0gVy-X7g`
          target=`_blank`
          @click.prevent="videoBtnClick"
        )
          base-picture(
            :minScreenWidth="videoThumb.minScreenWidth"
            :desktopName="videoThumb.desktopName"
            :mobileName="videoThumb.mobileName"
            :alt="videoThumb.alt"
          )

          svg.advantages__modal-icon.advantages__modal-icon--play.clr-white(xmlns=`http://www.w3.org/2000/svg`)
            use(:href="$setSvgHref(`img/sprite.svg#i-play`)")

</template>

<script>
export default {
  data () {
    return {
      pictures: [{
        imgClass: `picture__img--contain`,
        minScreenWidth: `1024px`,
        desktopName: `advantages-desktop-01`,
        mobileName: `advantages-desktop-01`,
        alt: `Центральный бортовой компьютер`
      }, {
        imgClass: `picture__img--contain`,
        minScreenWidth: `1024px`,
        desktopName: `advantages-desktop-02`,
        mobileName: `advantages-desktop-02`,
        alt: `ЦБК как «спрут» охватывает все системы бортового оборудования`
      }, {
        svgName: `i-advantages-desktop-03`
      }],
      lists: {
        blocks: [{
          items: [{
            class: `advantages__list-item clr-grey`,
            text: `Двухстороннего взаимодействия Водитель-диспетчер`
          }, {
            class: `advantages__list-item clr-grey`,
            text: `Информирования пассажиров о движении по маршруту`
          }, {
            class: `advantages__list-item clr-grey`,
            text: `Связи и позиционирования`
          }, {
            class: `advantages__list-item clr-grey`,
            text: `Подсчета пассажиров для определения статистики пассажиропотока`
          }]
        }, {
          items: [{
            class: `advantages__list-item clr-grey`,
            text: `Повысить эффективность использования систем транспортного средства`
          }, {
            class: `advantages__list-item clr-grey`,
            text: `Упростить взаимодействия водителя с ним`
          }, {
            class: `advantages__list-item clr-grey`,
            text: `Снизить время простоев из-за возникновения неисправностей подсистем оборудоваиня`
          }, {
            class: `advantages__list-item clr-grey`,
            text: `Создание комплексной картины работы бортового оборудования на транспортном средстве прямо на рабочем месте`
          }]
        }]
      },
      videoThumb: {
        minScreenWidth: `1024px`,
        desktopName: `advantages-video-thumb`,
        mobileName: `advantages-video-thumb`,
        alt: `Видеопрезентация: Архитерктура телематической системы со встроенным ЦБК`
      }
    }
  },
  computed: {
    videoVisible () {
      return this.$store.getters.videoVisible
    }
  },
  methods: {
    videoBtnClick () {
      if (this.videoVisible) {
        this.$store.dispatch(`hideVideoModal`)
      } else {
        this.$store.dispatch(`showVideoModal`)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .advantages {
    position: relative;

    &::before {
      @include font('x');
      content: 'ЦБК';
      position: absolute;
      top: 9.375vw;
      right: calc(100% - #{$offset-desktop});
      font-size: 18rem;
      line-height: 1;
      text-align: center;
      color: rgba(#717171, 0.1);
      writing-mode: vertical-rl;
      transform: rotate(180deg);
    }

    @include respond-max(tablet) {
      &::before {
        display: none;
      }
    }
  }

  .advantages__block {
    display: flex;
    padding-top: 9.375vw;
    padding-bottom: 8.33vw;

    &--reverse {
      flex-direction: row-reverse;
    }

    &:nth-of-type(1) {
      padding-bottom: 6.3vw;
    }

    @include respond-max(tablet) {
      flex-direction: column;
      padding-top: 4rem;
      padding-bottom: 4rem;
    }
  }

  .advantages__img-wrapper {
    display: flex;
    flex-shrink: 0;
    width: 48.5vw;

    .advantages__block--reverse & {
      justify-content: flex-end;
    }

    @include respond-max(tablet) {
      justify-content: center;
      width: 100%;
      margin-bottom: 4rem;

      .advantages__block--reverse & {
        justify-content: center;
      }
    }
  }

  .advantages__img {
    display: flex;
    flex-direction: column;

    .advantages__block--reverse & {
      align-items: flex-end;
    }

    .advantages__block & picture {
      width: 39.17vw;
      height: 40.52vw;
    }

    .advantages__block:nth-of-type(2) & picture {
      width: 37.41vw;
      height: 31.55vw;
    }

    .advantages__block:nth-of-type(3) & svg {
      width: 35.53vw;
      height: 31.25vw;
    }

    svg {
      width: 100%;
      height: 100%;
    }

    @include respond-max(tablet) {
      .advantages__block & picture {
        width: 100%;
      }

      .advantages__block--reverse & {
        align-items: center;
      }
    }
  }

  .advantages__img-caption {
    margin-top: 3.5rem;
    font-size: 0.9375rem;
    color: rgba($text-color, 0.8);

    @include respond-max(tablet) {
      margin-top: 1rem;
    }
  }

  .advantages__content {
    display: flex;
    flex-direction: column;
  }

  .advantages__title {
    margin-bottom: 3.5rem;
    word-break: break-word;
  }

  .advantages__text {
    width: 22.92vw;
    margin-bottom: 3.5rem;
    font-size: 1.125rem;
    line-height: 1.4;
    color: rgba($text-color, 0.8);

    @include respond-max(tablet) {
      width: 100%;
    }
  }

  .advantages__subtitle {
    width: 22.92vw;
    margin-bottom: 2.5rem;
    letter-spacing: 0.02em;

    @include respond-max(tablet) {
      width: 100%;
    }
  }

  .advantages__list {
    width: 25.83vw;

    @include respond-max(tablet) {
      width: 100%;
    }
  }

  .advantages__list-item {
    .advantages__block.bg-xl-blue /deep/ & {
      border-color: rgba(#616161, 0.3);
    }
  }

  .advantages__download {
    background-color: $blue;
    margin-top: 2.5rem;
    transition: $trs;

    &:hover {
      background-color: #5182dd;
    }

    .btn__text {
      text-align: center;
    }

    svg {
      flex-shrink: 0;
      width: 1.125rem;
      height: 1.40625rem;
      margin-right: 0.875rem;
    }
  }

  .advantages__video-caption {
    margin-bottom: 1.375rem;
    font-size: 1.125rem;
  }

  .advantages__video {
    overflow: hidden;
    position: relative;
    display: flex;
    width: 22.92vw;
    height: 12.34vw;
    background-color: rgba(#000000, 0.2);
    border-radius: 8px;

    /deep/ .picture__img {
      transition: $trs;
    }

    &:hover {
      /deep/ .picture__img {
        transform: scale(1.1);
      }
    }

    @include respond-max(tablet) {
      width: 10rem;
      height: 6rem;
    }
  }

  .advantages__modal-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    &--play {
      width: 30%;
      height: 30%;
      transform: translate(calc(-36%), -50%);
      transition: $trs;

      .advantages__video:hover & {
        color: $d-blue;
      }
    }
  }
</style>
